import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEOHelmet = ({ 
    title = "Fish MD - Instant Saltwater Fish Disease Diagnosis", 
    description = "Get an AI-powered diagnosis for your sick saltwater fish in minutes. Identify Ich, Marine Velvet, Brooklynella and more. Try Fish MD!",
    keywords = "saltwater fish diseases, marine fish illness, ich treatment, marine velvet, fish disease identification, aquarium fish health, fish symptoms checker",
    ogImage = "/fish-md-og-image.jpg",
    canonicalUrl = "",
    structuredData = null
}) => {
    const siteUrl = window.location.origin;
    const fullUrl = canonicalUrl ? `${siteUrl}${canonicalUrl}` : siteUrl;
    
    // Default structured data for the site
    const defaultStructuredData = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Fish MD",
        "alternateName": "fishpest.com",
        "url": siteUrl,
        "description": description,
        "applicationCategory": "HealthApplication",
        "operatingSystem": "Any",
    };

    return (
        <Helmet>
            <title>{title}</title>
            <meta name="description" content={description} />
            <meta name="keywords" content={keywords} />
            
            {/* Open Graph Tags */}
            <meta property="og:title" content={title} />
            <meta property="og:description" content={description} />
            <meta property="og:type" content="website" />
            <meta property="og:url" content={fullUrl} />
            <meta property="og:image" content={`${siteUrl}${ogImage}`} />
            
            {/* Canonical URL */}
            <link rel="canonical" href={fullUrl} />
            
            {/* Structured Data */}
            <script type="application/ld+json">
                {JSON.stringify(structuredData || defaultStructuredData)}
            </script>
        </Helmet>
    );
};

export default SEOHelmet; 